module.exports = __webpack_public_path__ + "img/supraespinhal.28c2a656.png";